import { GENERATE_URL } from "@services/helpers/request";

const PREFIX_URL = "/ShoppingBasket";

export const GetBasketList = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetBasketList/:customerId`, options);

export const Create = (options) => GENERATE_URL(`${PREFIX_URL}`, options);

export const RemoveBasketItem = (options) =>
  GENERATE_URL(`${PREFIX_URL}/RemoveBasketItem`, options);

export const AddQuantity = (options) =>
  GENERATE_URL(`${PREFIX_URL}/AddQuantity`, options);

export const GetShoppingBasketWithExtra = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetShoppingBasketWithExtra`, options);

export const GetProductsByRule = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetProductsByRule`, options);

export const GetExtraProductsByRule = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetExtraProductsByRule`, options);

export const AddProductByRule = (options) =>
  GENERATE_URL(`${PREFIX_URL}/AddProductByRule`, options);

export const ChangeExtraProduct = (options) =>
  GENERATE_URL(`${PREFIX_URL}/ChangeExtraProduct`, options);

export const GetBasketProductsWithRule = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetBasketProductsWithRule`, options);

export const AddExtraRuleBasket = (options) =>
  GENERATE_URL(`${PREFIX_URL}/AddExtraRuleBasket`, options);

export const AddOneTimeProduct = (options) =>
  GENERATE_URL(`${PREFIX_URL}/AddOneTimeProduct`, options);

export const RemoveRuleBasket = (options) =>
  GENERATE_URL(`${PREFIX_URL}/RemoveRuleBasket`, options);

export const Delete = (options) => GENERATE_URL(`${PREFIX_URL}/:id`, options);

export default {
  GetBasketList,
  Create,
  RemoveBasketItem,
  AddQuantity,
  GetShoppingBasketWithExtra,
  GetProductsByRule,
  GetExtraProductsByRule,
  AddProductByRule,
  ChangeExtraProduct,
  GetBasketProductsWithRule,
  AddExtraRuleBasket,
  AddOneTimeProduct,
  RemoveRuleBasket,
  Delete,
};
